/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import NProgress from 'nprogress'
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import HotelOptionsStore from '../../store/options/HotelOptionsStore'
import StripeKeyStore from '../../store/stripe_key/StripeKeyStore'
import SessionStore from '../../store/SessionStore'
import EditView from '../../view/pages/stripe_key/EditView'
import SessionAction from '../../action/session'
import StripeKeyAction from '../../action/stripe_key'

class EditContainer extends Component {
  static getStores() {
    return [StripeKeyStore, HotelOptionsStore, SessionStore]
  }

  static calculateState(prevState, props) {
    return {
      session: SessionStore.getState(),
      hotel_options: HotelOptionsStore.getState(),
      stripe_key: StripeKeyStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()
    const id = this.state.match.params.id
    if (id) {
      await StripeKeyAction.fetchOne(id)
    } else {
      await SessionAction.fetchUserHotels()
    }

    NProgress.done()
  }

  render() {
    return EditView(this.state)
  }
}

export default withRouter(Container.create(EditContainer, { withProps: true }))
